import { Injectable } from '@angular/core';


@Injectable()
export class LoggedUserService {

  data: any;

  constructor() { }

  saveInLocalStorage(user: any) {
    localStorage.setItem('user_data_ibank', JSON.stringify(user));
  }

  getFromLocalStorage() {
    var current_st_user = JSON.parse(localStorage.getItem('user_data_ibank'));
    if (current_st_user != null) {
      return current_st_user;
    } else {
      return new LoggedUserService();
    }
  }

  replaceInLocalStorage() {
    localStorage.removeItem('user_data_ibank');
    localStorage.setItem('user_data_ibank', JSON.stringify(this));
  }

  removeFromLocalStorage() {
    localStorage.removeItem('user_data_ibank');
  }

  isLoggedIn() {
    return (localStorage.getItem('user_data_ibank') != null) ? true : false;
  }

  getUserID() {
    var current_user = JSON.parse(localStorage.getItem('user_data_ibank'));
    return current_user?.id;
  }

  getAuthorizationToken() {
    var current_user = JSON.parse(localStorage.getItem('user_data_ibank'));
    return current_user?.token;
  }

  getRole() {
    var current_user = JSON.parse(localStorage.getItem('user_data_ibank'));
    return current_user?.role_id;
  }

}
